import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, useIntl } from 'react-intl';
import PackerRefundCalculator from './packerRefundCalculator';
import Modal from 'react-bootstrap/Modal';
import PAYMENT_REFUND_PAYER from '../../components/constants/paymentRefundPayer';
import ITEM_TEMPERATURE from '../../components/constants/itemTemperature';
import PackerDeliveryOrderItem from './packerDeliveryOrderItem';
import utils from '../../utils/utils';

const PackerDeliveryOrderItems = ({
  orderItems,
  addPackedItem,
  removePackedItemFromIndex,
  packedItemIds,
  order,
  refundOrderItems,
  addToRefunds,
  removeFromRefunds,
}) => {
  const [partialRefundOrderItem, setPartialRefundOrderItem] = useState(null);

  const addOrderItemToRefunds = (orderItem) => {
    const existingItems = refundOrderItems.filter((refundOrderItem) => refundOrderItem.orderItem.id === orderItem.id);
    const quantity = orderItem.fulfilledQuantity !== null ? orderItem.fulfilledQuantity : orderItem.quantity;

    if (existingItems.length >= quantity) {
      return;
    }

    // adding every quantity of item as a separate element for clarity on partial refunds where quantity > 1
    addToRefunds([
      {
        orderItem,
        amount: orderItem.itemPrice,
        orderId: orderItem.orderId,
        payer: PAYMENT_REFUND_PAYER.membo,
      },
    ]);
  };

  const removeOrderItemFromRefunds = (orderItem) => {
    const existingIndex = refundOrderItems.findIndex(
      (refundOrderItem) => refundOrderItem.orderItem.id === orderItem.id
    );

    if (existingIndex === -1) {
      return;
    }

    removeFromRefunds(existingIndex);
  };

  const tempEnums = Object.keys(ITEM_TEMPERATURE).map((key) => ITEM_TEMPERATURE[key]);

  orderItems.sort((a, b) => {
    const aPackingSection = a.item.marketplaces.length ? a.item.marketplaces[0].packingSection : null;
    const bPackingSection = b.item.marketplaces.length ? b.item.marketplaces[0].packingSection : null;

    if (aPackingSection && bPackingSection) {
      return aPackingSection.localeCompare(bPackingSection);
    } else if (aPackingSection && !bPackingSection) {
      return -1;
    } else if (!aPackingSection && bPackingSection) {
      return 1;
    } else {
      return a.itemName.localeCompare(b.itemName);
    }
  });

  const { formatMessage } = useIntl();

  // TODO remove getItemUnitQuantity after order items are being populated

  return (
    <>
      <ul>
        {orderItems.map((orderItem, index) => {
          const packedItemIndex = packedItemIds.findIndex(
            ({ itemId, orderId }) => itemId === orderItem.item.id && orderId === order.id
          );

          const onItemCheck = () => {
            if (packedItemIndex !== -1) {
              removePackedItemFromIndex(packedItemIndex);
            } else {
              addPackedItem({ itemId: orderItem.item.id, orderId: order.id });
            }
          };

          const refundedOrderItems = refundOrderItems.filter((roi) => roi.orderItem.id === orderItem.id);

          const refundButtons = refundedOrderItems.length ? (
            <span>
              <FontAwesomeIcon
                onClick={(e) => {
                  e.stopPropagation();
                  removeOrderItemFromRefunds(orderItem);
                }}
                className="m-r-1"
                icon={faMinusCircle}
              />
              {refundedOrderItems.length}
              <FontAwesomeIcon
                onClick={(e) => {
                  e.stopPropagation();
                  addOrderItemToRefunds(orderItem);
                }}
                className="m-l-1"
                icon={faPlusCircle}
              />
            </span>
          ) : (
            <span className="text-muted">
              <small
                onClick={(e) => {
                  e.stopPropagation();
                  addOrderItemToRefunds(orderItem);
                }}
                className="m-r-3 text-small"
              >
                <FormattedMessage id={'packer.delivery.order.batch.row.order.item.full.refund'} />
              </small>
              <small
                onClick={(e) => {
                  e.stopPropagation();
                  setPartialRefundOrderItem(orderItem);
                }}
                className="text-small"
              >
                <FormattedMessage id={'packer.delivery.order.batch.row.order.item.partial.refund'} />
              </small>
            </span>
          );

          const quantity = orderItem.fulfilledQuantity !== null ? orderItem.fulfilledQuantity : orderItem.quantity;

          const isPacked = packedItemIndex !== -1;

          return (
            <PackerDeliveryOrderItem
              key={index}
              item={orderItem.item}
              itemName={`${orderItem.itemName}${utils.getItemUnitQuantity(orderItem.item, formatMessage)}`}
              onItemCheck={onItemCheck}
              isPacked={isPacked}
              quantity={quantity}
              tempEnums={tempEnums}
              refundButtons={refundButtons}
            />
          );
        })}
      </ul>

      <Modal show={!!partialRefundOrderItem} onHide={() => setPartialRefundOrderItem(null)} size="md">
        <div onClick={() => setPartialRefundOrderItem(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal m-small-padding">
          {partialRefundOrderItem ? (
            <PackerRefundCalculator
              orderItem={partialRefundOrderItem}
              onSuccess={(refundOrderItems) => {
                addToRefunds(refundOrderItems);
                setPartialRefundOrderItem(null);
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>
    </>
  );
};

PackerDeliveryOrderItems.propTypes = {};

PackerDeliveryOrderItems.defaultProps = {};

export default PackerDeliveryOrderItems;
